const WORDS_PER_MINUTE = 110;

export const calculateTimeToRead = (timeToRead, body = "") => {
  return body
    ? parseInt(body.split(" ").length / WORDS_PER_MINUTE)
    : timeToRead;
};
